import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles(() => ({
  menu: {
    display: "block",
    boxSizing: "border-box",
    paddingLeft: "16px",
    paddingRight: "16px",
    margin: "0",
    listStyleType: "none",
  },
}));

function SideMenu(props) {
  const classes = useStyles();
  return <div className={classes.menu}>{props.children}</div>;
}

export default SideMenu;
